'use client'

import { Box, type SxProps } from '@mui/material'
import {
  ActionButton,
  ActionButtonData,
  Card,
  FeatureCardData,
  SectionHeader,
  SectionHeaderData,
  SectionWrapper,
  SectionWrapperProps,
} from '@components/common'
import { getStyles, useCardStyles } from '@utils/styles'
import defaultStyles from './styles'

export type FeatureShowCaseData = {
  sectionHeaderData?: SectionHeaderData
  featureCardData?: FeatureCardData[]
  darkBg?: boolean
}

export type FeatureShowCaseProps = FeatureShowCaseData & {
  actionButtonData?: ActionButtonData
  dark?: boolean
  showPreviewCards?: boolean
  sectionWrapperProps?: Partial<SectionWrapperProps>
  sectionHeaderWrapperStyled?: SxProps
  showDivider?: SectionWrapperProps['showDivider']
}

export function FeatureShowCase({
  sectionHeaderData,
  featureCardData,
  actionButtonData,
  dark,
  showPreviewCards,
  sectionWrapperProps,
  sectionHeaderWrapperStyled,
  showDivider = 'bottom',
  darkBg,
}: FeatureShowCaseProps) {
  const styles = getStyles(defaultStyles)

  const { cardStyles } = useCardStyles({
    count: featureCardData?.length || 0,
  })

  return (
    <SectionWrapper
      flexCol={{ xs: '20px', md: '32px' }}
      showDivider={showDivider}
      alternateBg={darkBg}
      {...sectionWrapperProps}
    >
      {sectionHeaderData && (
        <SectionHeader
          {...sectionHeaderData}
          csx={{
            wrapper: {
              ...sectionHeaderWrapperStyled,
            },
          }}
          darkBg={darkBg}
        />
      )}
      {!!featureCardData?.length && (
        <Box {...styles('cardWrapper')}>
          {featureCardData.map((item, idx) => (
            <Card
              type={showPreviewCards ? 'PreviewCard' : 'FeatureCard'}
              csx={{ wrapper: { ...cardStyles, flex: 1 } }}
              key={idx}
              {...item}
              animation="flip"
              dark={darkBg}
            />
          ))}
        </Box>
      )}
      {actionButtonData && (
        <ActionButton
          {...actionButtonData}
          csx={{
            button: styles('actionButton').sx,
          }}
          showArrow
        />
      )}
    </SectionWrapper>
  )
}
